import { render } from "./TextArea.vue?vue&type=template&id=beb28930&lang=pug"
import script from "./TextArea.vue?vue&type=script&setup=true&lang=js"
export * from "./TextArea.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__